import Raect from "react";

export const bgcolors = [
  {
    id: 1,
    color: "bg-[#291709]",
    ticked: false,
  },
  {
    id: 2,
    color: "bg-[#5F3310]",
    ticked: false,
  },
  {
    id: 3,
    color: "bg-[#7F4422]",
    ticked: false,
  },
  {
    id: 4,
    color: "bg-[#B26644]",
    ticked: false,
  },
  {
    id: 5,
    color: "bg-[#733F17]",
    ticked: false,
  },
  {
    id: 6,
    color: "bg-[#935F37]",
    ticked: false,
  },
  {
    id: 7,
    color: "bg-[#AD8A60]",
    ticked: false,
  },
];

export const bgimg = [
  {
    id: 1,
    url: "bg-bg1",
    ticked: false,
  },
  {
    id: 2,
    url: "bg-bg2",
    ticked: false,
  },
  {
    id: 3,
    url: "bg-bg3",
    ticked: false,
  },
  {
    id: 4,
    url: "bg-bg4",
    ticked: false,
  },
  {
    id: 5,
    url: "bg-bg5",
    ticked: false,
  },
  {
    id: 6,
    url: "bg-bg6",
    ticked: false,
  },
];
